export enum PaymentProcessorEnum {
  wompi = "wompi",
  blockbee = "blockbee",
}
